import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import FinancialTableHeader from '../../../molecules/table/FinancialTableHeader';
import FinancialTableRow from '../../../molecules/table/FinancialTableRow';
import styled from 'styled-components';
import Flex from '../../../atoms/Flex';
import { readableNumberParts } from '../../../../helpers/Numbers';
const TotalTableRow = styled(FinancialTableRow) `
    border-top: 2px solid #bcbcbc;
    border-radius: 1px;

    .table-cell__label {
        color: ${props => props.theme.primary.base};
        font-weight: 700;
        font-size: 18px;
    }

    .table-cell__value {
        color: ${props => props.theme.primary.base};
        font-weight: 700;
        font-size: 18px;
    }
`;
const SpecificationTable = ({ header, items, total, }) => {
    return (_jsxs(Flex, { column: true, children: [header && _jsx(FinancialTableHeader, { title: header }), _jsx(_Fragment, { children: items.map(item => (_jsx(FinancialTableRow, { noHover: true, label: item.label, amount: readableNumberParts(item.value, 'EUR').longDecimal, date: item.date }, item.label))) }), _jsx(TotalTableRow, { noHover: true, label: total.label, amount: readableNumberParts(total.value, 'EUR').longDecimal })] }));
};
export default SpecificationTable;
